import { render, staticRenderFns } from "./voluntaryRecruitment.vue?vue&type=template&id=412d2c29&scoped=true&"
import script from "./voluntaryRecruitment.vue?vue&type=script&lang=js&"
export * from "./voluntaryRecruitment.vue?vue&type=script&lang=js&"
import style0 from "./voluntaryRecruitment.vue?vue&type=style&index=0&lang=css&"
import style1 from "./voluntaryRecruitment.vue?vue&type=style&index=1&id=412d2c29&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412d2c29",
  null
  
)

export default component.exports